<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>会员分析</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;">
      <el-date-picker
        v-model="memberRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectDate"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-select v-model="contact" size="mini" style="width: 200px" value clearable filterable
                 placeholder="是否联系" class="select" :disabled="memberRequest.selectDate == '' || memberRequest.selectDate == null"
                 @change="getIsContact">
        <el-option
          v-for="contact in isContact"
          :key="contact.id"
          :label="contact.label"
          :value="contact.id">
        </el-option>
      </el-select>

      <el-select v-model="memberRequest.memberType" size="mini" style="width: 200px"
                 value clearable filterable placeholder="客户类型" class="select" @change="">
        <el-option
          v-for="member in memberType"
          :key="member.id"
          :label="member.label"
          :value="member.id">
        </el-option>
      </el-select>

      <el-select v-model="memberRequest.activateType" size="mini" style="width: 200px" value clearable filterable
                 placeholder="激活方式" :disabled="contact == 2" class="select" @change="">
        <el-option
          v-for="member in activateType"
          :key="member.id"
          :label="member.label"
          :value="member.label">
        </el-option>
      </el-select>

      <el-select v-model="memberRequest.customerType" size="mini" style="width: 200px" value clearable filterable
                 placeholder="会员类别" class="select" @change="">
        <el-option
          v-for="customer in customerType"
          :key="customer.id"
          :label="customer.label"
          :value="customer.id">
        </el-option>
      </el-select>
      <el-button size="mini" @click="query">查询</el-button>
    </div>
    <div>
      <el-button v-if="orgLevel < 3" size="mini" @click="showPhoneMsgDialog">短信模板</el-button>
      <el-button size="mini" @click="yjfdx" :disabled="memberRequest.memberType == ''" >一键发短信</el-button>
      <el-button size="mini" @click="yjfwx" :disabled="memberRequest.memberType == ''">一键发微信</el-button>
      <el-button size="mini" @click="yjddh" :disabled="memberRequest.memberType == ''">一键打电话</el-button>
      <el-button size="mini" @click="yjfyhq" :disabled="memberRequest.memberType == ''">一键发优惠券</el-button>
    </div>
    <el-table height="650px" :data="memberList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :cell-style="orderStateColor"
              @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="center"
        width="50px"
        type="selection">
      </el-table-column>
      <el-table-column
        align="center"
        label="操作"
      >
        <template slot-scope="scope">
          <div style="display: flex;justify-content: space-around">
            <el-link type="primary"  icon="iconfont icon-duanxin1" title="发短信"
                     @click="execSendPhoneMsg(scope.row)"></el-link>
            <el-link type="primary"  icon="iconfont icon-weixin" title="发微信"
                     :disabled="scope.row.openId == '' || scope.row.openId == null" @click="sendWx(scope.row)"></el-link>
            <el-link type="primary"  icon="iconfont icon-dianhua" title="打电话"
                     @click="phone(scope.row)"></el-link>
            <el-link type="primary"  icon="iconfont icon-quan" title="发优惠券"
                     @click="showShopDiscountTicket(scope.row)"></el-link>
            <el-link type="primary"  icon="iconfont icon-dangan" title="会员档案"
                     @click.prevent="toDetail(scope.row.id)" ></el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="customerName"
        label="姓名"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="gender"
        :formatter="ganderFormatter"
        label="性别"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="phone"
        label="手机号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="registerOrgName"
        label="注册机构"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="openId"
        :formatter="openIdFormatter"
        label="绑定微信"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="contactTime"
        label="联系时间"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="activateType"
        label="激活方式"
      >
      </el-table-column>
    </el-table>
<!--    <div style="margin-top: 3px;">-->
<!--      <el-pagination-->
<!--        @size-change="handleSizeChange"-->
<!--        @current-change="handleCurrentChange"-->
<!--        :current-page="currentPage"-->
<!--        :page-sizes="[10, 20, 30, 50]"-->
<!--        :page-size="pageSize"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        :total="pageTotal">-->
<!--      </el-pagination>-->
<!--    </div>-->

    <!-- 编辑短信 -->
    <el-dialog
      title="短信模板"
      :visible.sync="phoneMsgDialogVisible"
      width="60%"
      @close="closePhoneMsgDialog"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-button size="mini" @click="showAddPhoneMsgDialog(null, 1)">编辑短信模板</el-button>
      <el-table height="550px" :data="phoneMsgList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}">
        <el-table-column
          label="操作"
          align="center"
          width="100">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-evenly">
              <el-link type="primary" icon="el-icon-edit"
                       @click="showAddPhoneMsgDialog(scope.row, 2)"></el-link>
              <el-link type="primary" icon="el-icon-delete"
                       @click="deletePhoneMsg(scope.row)"></el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="msgType"
          label="客户类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="context"
          label="内容"
          align="center">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="currentPage1"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal1">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      title="短信模板"
      :visible.sync="phoneAddMsgDialogVisible"
      width="60%"
      @close="closeAddPhoneMsgDialog"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="height: 80px;display: flex;justify-items: flex-start">
        <el-select v-model="phoneMsg.msgType" size="mini" style="width: 200px"
                   value clearable filterable placeholder="客户类型" class="select" @change="">
          <el-option
            v-for="member in memberType"
            :key="member.id"
            :label="member.label"
            :value="member.label">
          </el-option>
        </el-select>
        <el-input v-model="phoneMsg.context" placeholder="请输入短信内容" size="60"></el-input>
      </div>
      <span class="dialog-footer">
        <el-button size="mini" @click="closeAddPhoneMsgDialog">取 消</el-button>
        <el-button size="mini" @click="execCreate">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑短信 -->
    <el-dialog
      title="短信模板"
      :visible.sync="phoneMsgListDialogVisible"
      width="60%"
      @close="closePhoneMsgListDialog"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table height="550px" :data="selectPhoneMsgList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}">
        <el-table-column
          label="操作"
          align="center"
          width="100">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="phoneMsg"  @change.native="selectEmployee(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="areaName"
          label="所属区域"
          align="center">
        </el-table-column>
        <el-table-column
          prop="msgType"
          label="客户类型"
          align="center">
        </el-table-column>
        <el-table-column
          prop="context"
          label="内容"
          align="center">
        </el-table-column>
      </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="currentPage2"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal2">
        </el-pagination>
      </div>
      <span class="dialog-footer">
        <el-button size="mini" @click="closePhoneMsgListDialog">取 消</el-button>
        <el-button size="mini" @click="sendMsg">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 优惠券 -->
    <el-dialog
      title="优惠券列表"
      :visible.sync="shopDiscountTicketDialogVisible"
      width="60%"
      @close="closeShopDiscountTicket"
      style="position: absolute"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table height="500px" :data="shopDiscountTicketList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="{height: '0'}">
        <el-table-column
          label="操作"
          align="center"
          width="100">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="selectedShopDiscountTicket"
                      @change.native="selectShopDiscountTicket(scope.row)">{{''}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="优惠券名成"
          align="center" width="150">
        </el-table-column>
        <el-table-column
          prop="ticketTypeName"
          label="优惠券类型"
          align="center" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="money"
          label="面额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="fullMoney"
          label="满金额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="subMoney"
          label="减金额" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="rate"
          label="折扣率" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="consumptionName"
          label="单品名称" width="200">
        </el-table-column>
        <el-table-column
          align="center"
          prop="validDate"
          label="有效期" width="150">
        </el-table-column>
      </el-table>
<!--      <div style="margin-top: 3px;">-->
<!--        <el-pagination-->
<!--          @size-change="ticketHandleSizeChange"-->
<!--          @current-change="ticketHandleCurrentChange"-->
<!--          :current-page="ticketCurrentPage"-->
<!--          :page-sizes="[10, 20, 30, 50]"-->
<!--          :page-size="ticketPageSize"-->
<!--          layout="total, sizes, prev, pager, next, jumper"-->
<!--          :total="ticketPageTotal">-->
<!--        </el-pagination>-->
<!--      </div>-->
      <span class="dialog-footer">
        <el-button size="mini" @click="closeShopDiscountTicket">取 消</el-button>
        <el-button size="mini" @click="sendShopDiscountTicket">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      shopId:'',
      userId:'',
      orgLevel:'',
      memberList:[],
      memberType:[
        {id: 1, label: '活跃客户'},
        {id: 2, label: '迟缓客户'},
        {id: 3, label: '提醒客户'},
        {id: 4, label: '失联客户'}
      ],
      activateType:[
        {id: 1, label: '短信'},
        {id: 2, label: '微信'},
        {id: 3, label: '电话'},
        {id: 4, label: '优惠券'}
      ],
      customerType:[{id: 1, label: '储值会员'}, {id: 2, label: '康复会员'}, {id: 3, label: '非储值会员'}],
      isContact:[{id: 1, label: '已联络'}, {id: 2, label: '未联络'}],
      contact:'',
      memberRequest:{
        memberType:'',
        activateType:'',
        customerType:'',
        selectDate:'',
        isContact:'',
        shopId:'',
        pageSize:'',
        pageNum:'',
        lxStartDate:'',
        lxEndDate:'',
        orgLevel:''
      },
      ticketRequest:{
        shopId:'',
        pageSize:'',
        pageNum:'',
      },
      currentPage: 1,
      pageSize:20,
      pageTotal:0,

      currentPage1: 1,
      pageSize1:20,
      pageTotal1:0,

      currentPage2: 1,
      pageSize2:20,
      pageTotal2:0,
      ganderText:[
        {gander:0,name:'未知'},
        {gander:1,name:'男'},
        {gander:2,name:'女'},
      ],
      openIdText:[
        {openId:1,name:'是'},
        {openId:2,name:'否'},
      ],
      selectMemberAnalyse:[],
      selectOneMemberAnalyse:'',
      phoneMsg:{
        id:'',
        areaId:'',
        context:'',
        msgType:'',
      },
      selectedPhoneMsg:'',
      phoneMsgList:[],
      selectPhoneMsgList:[],
      phoneMsgDialogVisible:false,
      phoneMsgListDialogVisible:false,
      phoneAddMsgDialogVisible:false,
      phoneMsgOperateType:'',
      sendType:'',
      memberAnalyseInfo:{
        memberAnalyses:[],
        context:'',
        request:'',
        shopDiscountTicket:''
      },

      shopDiscountTicketDialogVisible:false,
      shopDiscountTicketList:[],
      selectedShopDiscountTicket:'',
      ticketCurrentPage: 1,
      ticketPageSize:99999,
      ticketPageTotal:0,
    }
  },
  methods:{
    orderStateColor({row,columnIndex}){
      if ((row.openId != '' && row.openId != null)  && columnIndex ===2){
        return 'color:#0CB618';
      }
    },
    initPhoneMsg(){
      this.phoneMsg.id='';
      this.phoneMsg.areaId='';
      this.phoneMsg.msgType='';
      this.phoneMsg.context='';
    },
    showPhoneMsgDialog(){
      this.phoneMsgDialogVisible = true;
      this.loadPhoneMsg();
    },
    closePhoneMsgDialog(){
      this.phoneMsgDialogVisible = false;
    },
    showAddPhoneMsgDialog(row, type){
      this.initPhoneMsg();
      this.phoneMsgOperateType = type;
      if (type === 2){
        this.phoneMsg = row;
      }
      this.phoneAddMsgDialogVisible = true;
    },
    closeAddPhoneMsgDialog(){
      this.phoneAddMsgDialogVisible = false;
    },
    showPhoneMsgListDialog(){
      this.phoneMsgListDialogVisible = true;
    },
    closePhoneMsgListDialog(){
      this.phoneMsgListDialogVisible = false;
    },
    selectDate(){
      if (this.memberRequest.selectDate === null){
        this.memberRequest.lxStartDate = '';
        this.memberRequest.lxEndDate = '';
        this.memberRequest.isContact = 0;
        this.contact = ''
      } else {
        this.memberRequest.lxStartDate = this.memberRequest.selectDate[0];
        this.memberRequest.lxEndDate = this.memberRequest.selectDate[1];
      }
    },
    query(){
      if (this.memberRequest.selectDate != null && this.memberRequest.selectDate != ''){
        if (this.memberRequest.isContact == 0){
          return this.$message.warning("请选择是否联系！")
        }
      }
      this.currentPage = 1;
      // this.queryMemberCount();
      this.queryMemberList();
    },
    async queryMemberCount(){
      const {data:res} = await this.$http.post(`/member/analyse/count`, this.memberRequest);
      this.pageTotal = res.totalPage;
    },
    async queryMemberList(){
      this.memberRequest.pageNum = this.currentPage;
      this.memberRequest.pageSize = this.pageSize;
      const {data:res} = await this.$http.post(`/member/analyse/list`, this.memberRequest);
      this.memberList = res.data;
    },
    // handleSizeChange(val) {
    //   this.pageSize = val;
    //   this.queryMemberList();
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val;
    //   this.queryMemberList();
    // },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.loadPhoneMsgList();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.loadPhoneMsgList();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.loadSelectPhoneMsgList();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.loadSelectPhoneMsgList();
    },
    ganderFormatter(row){
      let value = "";
      for (let i = 0; i < this.ganderText.length; i++){
        let item = this.ganderText[i];
        if (row.gender === item.gander) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    openIdFormatter(row){
      let value = "";
      for (let i = 0; i < this.openIdText.length; i++){
        let item = this.openIdText[i];
        if (row.openId === item.openId) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    getIsContact(){
      this.memberRequest.isContact = this.contact;
    },
    toDetail(item){
      this.$router.push({path:'/card',query:{id:item}});
    },
    async phone(row){
      const {data:res} = await this.$http.post(`/member/analyse/phone/${this.shopId}`, row);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.error("操作失败！")
      }
      // await this.queryMemberCount();
      await this.queryMemberList();
    },
    async yjfwx(){
      this.memberAnalyseInfo.memberAnalyses = this.selectMemberAnalyse;
      this.memberAnalyseInfo.context = '';
      this.memberAnalyseInfo.request = {};
      this.memberAnalyseInfo.shopDiscountTicket = {};
      const {data:res} = await this.$http.post(`/member/analyse/oneKeySendWx`, this.memberAnalyseInfo);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.error("操作失败！")
      }
    },
    sendWx(row){
      this.$http.post(`/member/analyse/sendWx`, row).then(res => {
        if (res.data.code === 200){
          return this.$message.success("操作成功！")
        } else {
          return this.$message.error("操作失败！")
        }
      });
    },
    execSendPhoneMsg(row){
      this.phoneMsg = '';
      this.selectOneMemberAnalyse = row;
      this.sendType = 1;
      this.showPhoneMsgListDialog();
      this.loadSelectPhoneMsg();
    },
    sendMsg(){
      if (this.sendType === 1){
        this.sendPhoneMsg();
      }
      if (this.sendType === 2){
        this.batchSendMsg();
      }
    },
    async sendPhoneMsg(){
      this.selectOneMemberAnalyse.context = this.selectedPhoneMsg.context;
      const {data:res} = await this.$http.post(`/member/analyse/sendMsg/${this.shopId}`, this.selectOneMemberAnalyse);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.error("操作失败！")
      }
      await this.queryMemberCount();
      await this.queryMemberList();
      this.closePhoneMsgListDialog();
    },
    handleSelectionChange(val){
      this.selectMemberAnalyse = val;
    },
    async yjfdx(){
      this.phoneMsg = '';
      this.sendType = 2;
      this.showPhoneMsgListDialog();
      this.loadSelectPhoneMsg();
    },
    async batchSendMsg(){
      this.memberAnalyseInfo.memberAnalyses = this.selectMemberAnalyse;
      this.memberAnalyseInfo.context = this.selectedPhoneMsg.context;
      this.memberAnalyseInfo.request = this.memberRequest;
      this.memberAnalyseInfo.shopDiscountTicket = {};
      const {data:res} = await this.$http.post(`/member/analyse/oneKeySendMsg/${this.shopId}`, this.memberAnalyseInfo);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.error("操作失败！")
      }
      // await this.queryMemberCount();
      await this.queryMemberList();
      this.closePhoneMsgListDialog();
    },
    async yjddh(){
      this.memberAnalyseInfo.memberAnalyses = this.selectMemberAnalyse;
      this.memberAnalyseInfo.request = this.memberRequest;
      const {data:res} = await this.$http.post(`/member/analyse/oneKeyPhone/${this.shopId}`, this.memberAnalyseInfo);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.error("操作失败！")
      }
      await this.queryMemberCount();
      await this.queryMemberList();
    },

    execCreate(){
      if(this.phoneMsgOperateType === 1){
        this.createPhoneMsg();
      }
      if (this.phoneMsgOperateType === 2){
        this.editPhoneMsg();
      }
      this.closeAddPhoneMsgDialog();
    },
    async createPhoneMsg(){
      this.phoneMsg.areaId = this.shopId;
      this.phoneMsg.orgLevel = this.orgLevel;
      const {data:res} = await this.$http.post(`/phone/msg/add`, this.phoneMsg);
      if (res.code === 200){
        this.$message.success("操作成功！");
      } else {
        this.$message.success("操作失败！");
      }
      await this.loadPhoneMsg();
    },
    async editPhoneMsg(){
      this.phoneMsg.areaId = this.shopId;
      this.phoneMsg.orgLevel = this.orgLevel;
      const {data:res} = await this.$http.post(`/phone/msg/edit`, this.phoneMsg);
      if (res.code === 200){
        this.$message.success("操作成功！");
      } else {
        this.$message.success("操作失败！");
      }

      await this.loadPhoneMsg();
    },
    async deletePhoneMsg(row){
      const {data:res} = await this.$http.post(`/phone/msg/delete/${row.id}`);
      if (res.code !== 200){
        this.$message.success("操作成功！");
      } else {
        this.$message.success("操作失败！");
      }
      await this.loadPhoneMsg();
    },
    loadPhoneMsg(){
      this.currentPage1 = 1;
      this.memberRequest.pageNum = this.currentPage1;
      this.loadPhoneMsgCount();
      this.loadPhoneMsgList();
    },
    async loadPhoneMsgCount(){
      const {data:res} = await this.$http.post(`/load/phone/msg/count`, this.memberRequest);
      if (res.code === 200){
        this.pageTotal1 = res.totalPage;
      }
    },
    async loadPhoneMsgList(){
      this.memberRequest.pageSize = this.pageSize1;
      const {data:res} = await this.$http.post(`/load/phone/msg/list`, this.memberRequest);
      if (res.code === 200){
        this.phoneMsgList = res.data;
      }
    },
    loadSelectPhoneMsg(){
      this.currentPage2 = 1;
      this.memberRequest.pageNum = this.currentPage2;
      this.loadSelectPhoneMsgCount();
      this.loadSelectPhoneMsgList();
    },
    async loadSelectPhoneMsgCount(){
      const {data:res} = await this.$http.post(`/load/phone/msg/count`, this.memberRequest);
      if (res.code === 200){
        this.pageTotal2 = res.totalPage;
      }
    },
    async loadSelectPhoneMsgList(){
      this.memberRequest.pageSize = this.pageSize2;
      const {data:res} = await this.$http.post(`/load/phone/msg/list`, this.memberRequest);
      if (res.code === 200){
        this.selectPhoneMsgList = res.data;
      }
    },
    selectEmployee(data){
      this.selectedPhoneMsg = data;
      this.sendMsg();
    },
    //发送优惠券部分
    yjfyhq(){
      this.sendType = 2;
      this.loadShopDiscountTicket();
      this.shopDiscountTicketDialogVisible = true;
    },
    showShopDiscountTicket(row){
      this.sendType = 1;
      this.selectOneMemberAnalyse = row;
      this.loadShopDiscountTicket();
      this.shopDiscountTicketDialogVisible = true;
    },
    closeShopDiscountTicket(){
      this.shopDiscountTicketDialogVisible = false;
    },
    selectShopDiscountTicket(data){
      this.selectedShopDiscountTicket = data;
      this.closeShopDiscountTicket();
      this.sendShopDiscountTicket();
    },
    async sendShopDiscountTicket(){
      if(this.sendType == 1){
       await this.sendOneShopDiscountTicket();
      }else{
        await this.batchSendShopDiscountTicket();
      }
    },
    //单个发送优惠券
    async sendOneShopDiscountTicket(){
      this.selectOneMemberAnalyse.shopDiscountTicket = this.selectedShopDiscountTicket;
      this.selectOneMemberAnalyse.shopId = this.shopId;
      this.selectOneMemberAnalyse.creator = this.userId;
      const {data:res} = await this.$http.post(`/member/analyse/discountTicket`, this.selectOneMemberAnalyse);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.error("操作失败！")
      }
    },
    //批量发送优惠券
    async batchSendShopDiscountTicket(){
      this.memberAnalyseInfo.memberAnalyses = this.selectMemberAnalyse;
      this.memberAnalyseInfo.shopDiscountTicket = this.selectedShopDiscountTicket;
      this.memberAnalyseInfo.request = {};
      this.memberAnalyseInfo.creator = this.userId;
      const {data:res} = await this.$http.post(`/member/analyse/oneKeyDiscountTicket`, this.memberAnalyseInfo);
      if (res.code === 200){
        this.$message.success("操作成功！")
      } else {
        this.$message.error("操作失败！")
      }
      // await this.queryMemberCount();
      await this.queryMemberList();
      this.closePhoneMsgListDialog();
    },
    loadShopDiscountTicket(){
      this.ticketRequest.pageNum = this.ticketCurrentPage;
      this.ticketRequest.pageSize = this.ticketPageSize;
      this.ticketRequest.shopId = this.shopId;
      this.loadShopDiscountTicketCount();
      this.loadShopDiscountTicketList();
    },
    async loadShopDiscountTicketCount(){
      const {data:res} = await this.$http.post(`/load/shop/ticket/count`, this.ticketRequest);
      this.ticketPageTotal = res.totalPage;
    },
    async loadShopDiscountTicketList(){
      const {data:res} = await this.$http.post(`/load/shop/ticket/list`, this.ticketRequest);
      if (res.code === 200){
        this.shopDiscountTicketList = res.data;
      }
    },
    ticketHandleSizeChange(val) {
      this.ticketPageSize = val;
      this.loadShopDiscountTicketList();
    },
    ticketHandleCurrentChange(val) {
      this.ticketCurrentPage = val;
      this.loadShopDiscountTicketList();
    },
  },
  created() {
    this.shopId = window.sessionStorage.getItem('currentOrgId');
    this.orgLevel = window.sessionStorage.getItem('orgLevel');
    this.userId = window.sessionStorage.getItem("userId");
    this.memberRequest.shopId = this.shopId;
    this.memberRequest.orgLevel = this.orgLevel;
  }
}
</script>
<style lang="less" scoped>
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
  text-align: center !important;
}
/deep/ td {
  padding: 2px ;
}
}
/deep/.el-input__inner{
  height: 30px;
  line-height: 30px;
}
/deep/.el-input__icon,.el-icon-date{
  line-height: 35px;
}
/deep/.el-input__icon, .el-range__icon, .el-icon-date{
  line-height: 25px;
}
/deep/.el-range-separator{
  line-height: 23px;
}
.dialog-footer{
  display: flex;
  margin: 0 0 0 0;
  justify-content: center;
  width: 100%;
}
/deep/.el-button--text{
  color: #ecf5ff;
}
.el-table {
  overflow: visible !important;
//overflow: auto !important;
}

/deep/.el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #E4E7ED;
}
/deep/.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 10px;
}
/deep/.el-tabs__content {
  overflow: hidden;
  position: relative;
  height: 600px;
}
/deep/.el-table__body-wrapper .is-scrolling-left{
  height: 483px;
}
/deep/.el-tabs__content.el-table__fixed{
  height: 539px;
}
/deep/ .el-table__fixed{
  height: 100% !important;
}
/deep/ .el-table__fixed-right,.el-table__fixed-body-wrapper{
  height: 100% !important;
}
/deep/.el-dialog__body {
  padding: 5px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/Analyse.vue